
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data/uscis-status-explorer/[messageSlug]",
      function () {
        return require("private-next-pages/data/uscis-status-explorer/[messageSlug].tsx");
      }
    ]);
  